export default __webpack_public_path__ + "static/AndyKrivy-fa4f7d8b45fca02fef56f16b1a5338cd.jpg";